import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import {setSelectedFilters, showFilters} from "../../../../actions/actionFunctions";
import GroheFiltersSearchInputAsync from "../../grohe/groheNavigation/groheFilters/groheFiltersSearchInputAsync";
import LookFiltersList from "./lookFiltersList";
import LookFiltersReset from "./lookFiltersReset";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {setSQFTActiveLevel3Button} from "../../../../actions/sqftMenuFunctions";


const LookFilters = (props) => {
  const { wrapperStyles, filtersOpened, intl, showFilters, lookActiveCategory, isMobile, lookActiveFeature,
    selectedFilters, groheFiltersSearchText } = props;
  const { isRelatedItemsFilters, shouldCloseLevel3Sidebar, setSQFTActiveLevel3Button } = props;

  const closeFilterClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeaturesFiltersClose);
    showFilters(!filtersOpened);
    if (shouldCloseLevel3Sidebar) {
      setSQFTActiveLevel3Button(null);
    }
  };

  if (!lookActiveCategory) {
    return null
  }

  //console.log("availableFilters", availableFilters);

  return (
    <div className={"lm-content lm-content--filters" + (!filtersOpened || (isMobile && lookActiveFeature) ? " lm-content--slide-up" : "")}
         style={wrapperStyles || {}}>
      <div className="grohe-container grohe-filters">
        <div className="lk-title lk-title--centered">
          <h2 className="h3 lk-title__text2"><FormattedMessage id={"grohe.filter.title"}/></h2>
          <IconButton aria-label={intl.formatMessage({id:"iconButton.close"})}
                      className="look-icon look-icon--small"
                      onClick={closeFilterClick}>
            <CloseIcon/>
          </IconButton>
        </div>
        <div className="lk-description">
          <FormattedMessage id="grohe.filter.subTitle"/>
        </div>
        <GroheFiltersSearchInputAsync/>
        <LookFiltersList className="lk-filters" isRelatedItemsFilters={isRelatedItemsFilters} />
        {selectedFilters.length || groheFiltersSearchText ? <LookFiltersReset/> : null}
      </div>
    </div>
  )
};

LookFilters.propTypes = {
  wrapperStyles: PropTypes.object,
  isRelatedItemsFilters: PropTypes.bool,
  shouldCloseLevel3Sidebar: PropTypes.bool
}

const mapStateToProps = (store) => {
  const {lookActiveCategory, lookActiveFeature} = store.lookState;
  const {showFilters, selectedFilters} = store.filterState;
  const {isMobile} = store.serverState;
  const {groheFiltersSearchText} = store.groheState;

  return {
    filtersOpened: showFilters,
    selectedFilters,
    lookActiveCategory,
    lookActiveFeature,
    isMobile,
    groheFiltersSearchText,
  };
};

const mapDispatchToProps = {
  showFilters,
  setSelectedFilters,
  setSQFTActiveLevel3Button,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookFilters)
);
